import React from 'react';
import ReactDOM from 'react-dom'

export default function Footer() {
    return(
        <footer className="footer">
          <div className="d-sm-flex justify-content-center justify-content-sm-between">
            
            <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Copyright © 2023 <a href="http://getbound.ai/">Getbound.ai</a> - All rights reserved</span>
          </div>
        </footer>
    )
}